/* Keep the approved grain on warm paper surfaces, including refreshed drawers. */
(() => {
  const surfaces = 'body,main,section,header,footer,div,article,aside,nav,li,form,fieldset,details,summary,dialog,table,thead,tbody,tr,td,th,dl,dt,dd';
  const media = '.card__inner,.card__media,.product__media,.product-media-container,.thumbnail,.cabane-recommendations__image,.setup-bundle__media,.lcg-wishlist__item-image,.lcg-search__result-image';
  const pending = new Set();
  const pendingTrees = new Set();
  let scheduled = false;

  function readPaper(element) {
    if (!(element instanceof HTMLElement) || !element.matches(surfaces)) return;
    const style = getComputedStyle(element);
    const channels = style.backgroundColor.match(/[\d.]+/g)?.map(Number);
    const [r=0,g=0,b=0,a=1] = channels || [];
    const paperTexture = /cabane-street-grain\.svg|cabane-paper-texture\.webp/.test(style.backgroundImage);
    const photographic = /url\(/.test(style.backgroundImage) && !paperTexture;
    const paper = a >= .99 && r >= 230 && r >= g && g >= b && r-b >= 10 && r-b <= 45;
    return paper && !photographic && !element.closest(media);
  }

  // Read every computed style before changing attributes: one style calculation per batch.
  function flush() {
    scheduled = false;
    const elements = new Set(pending);
    const roots = [...pendingTrees].filter(root => root.isConnected);
    pending.clear();
    pendingTrees.clear();
    for (const root of roots) {
      if (roots.some(other => other !== root && other.contains(root))) continue;
      elements.add(root);
      root.querySelectorAll(surfaces).forEach(element => elements.add(element));
    }
    const changes = [];
    for (const element of elements) {
      if (!element.isConnected || !element.matches(surfaces)) continue;
      const paper = readPaper(element);
      if (element.hasAttribute('data-cabane-paper-grain') !== paper) changes.push([element, paper]);
    }
    for (const [element, paper] of changes) element.toggleAttribute('data-cabane-paper-grain', paper);
  }

  function schedule(element, tree = true) {
    if (!(element instanceof HTMLElement)) return;
    (tree ? pendingTrees : pending).add(element);
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(flush);
  }

  function boot() {
    pendingTrees.add(document.body);
    flush();
    const observer = new MutationObserver(records => {
      for (const record of records) {
        if (record.type === 'attributes') schedule(record.target, false);
        else record.addedNodes.forEach(node => schedule(node));
      }
    });
    observer.observe(document.body,{subtree:true,childList:true,attributes:true,attributeFilter:['class','style']});
    document.addEventListener('shopify:section:load',event=>schedule(event.target));
    window.addEventListener('load',()=>schedule(document.body),{once:true});
    // A breakpoint can change a transparent panel into an opaque paper surface.
    const mobile = window.matchMedia('(max-width: 749px)');
    mobile.addEventListener('change',()=>schedule(document.body));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',boot,{once:true});
  else boot();
})();
